import { FC, useEffect, useState } from "react"
import { CreateVariant } from "../../../MasterTabsProvider"
import { checkLockStatus } from "../../../CommonHelperFunctions"
import { useAppContext } from "../../../../system/providers/appContextProvider"
import { useTabsContext } from "../../../../system/providers/tabsProvider"
import { useUserContext } from "../../../../system/providers/userContextProvider"
import { ExportDocumentToolsCreate } from "../components/ExportDocumentToolsCreate"
import { IExportToolsDTO } from "../../../../libs/coreapi-dto/dirs/exportDocument"
import { ExportDocumentDataProvider } from "../../../../Services/DataProviders/ExportDocumentDataProvider"

interface IExportDocumentToolsCreatePluginViewProps {
    variant: CreateVariant
    idGlobal?: string
    createdCallback?: () => void
    permission: IPermission
}

export const ExportDocumentToolsCreatePluginView: FC<IExportDocumentToolsCreatePluginViewProps> = (props) => {
    const tabsContext = useTabsContext();
    const appContext = useAppContext();
    const userContext = useUserContext();

    const exportProvider = new ExportDocumentDataProvider(appContext.coreApiService)
    const lockFromPermission = checkLockStatus(props.permission as IPermission, userContext.userPermission);
    const [viewState, setViewState] = useState<GridStateType>(props.variant);
    const [id, setId] = useState<string | undefined>(props.idGlobal);
    const [form, setForm] = useState(<></>);

    useEffect(() => {
        renderForm()
    }, [viewState])

    function renderCreator(): void {
        setForm(
            <ExportDocumentToolsCreate
                data={null}
                variant='create'
                ok={(data: IExportToolsDTO) => {
                    exportProvider.create(data, (id: string) => {
                        tabsContext.closeCurrent()
                        props.createdCallback?.()
                        setId(id)
                        setViewState("create")
                    })
                }}
                save={(data: IExportToolsDTO) => {
                    exportProvider.create(data, (id: string) => {
                        props.createdCallback?.()
                        setId(id);
                        setViewState('edit');
                    })
                }}
                cancel={() => tabsContext.closeCurrent()}
            />
        )
    }

    function renderEditor(): void {
        if (id) {
            exportProvider.getById(id, (entity) => {
                setForm(
                    <ExportDocumentToolsCreate
                        data={entity}
                        variant='edit'
                        ok={(data: IExportToolsDTO) => {
                            exportProvider.update(id, data, () => {
                                tabsContext.closeCurrent()
                                props.createdCallback?.()
                            })
                        }}
                        save={(data: IExportToolsDTO) => {
                            exportProvider.update(id, data, () => {
                                props.createdCallback?.()
                            })
                        }}
                        cancel={() => tabsContext.closeCurrent()}
                        lockFromPermission={lockFromPermission}
                    />
                )
            })
        }
    }

    function renderCopy(): void {
        if (id) {
            exportProvider.getById(id, (entity) => {
                setForm(
                    <ExportDocumentToolsCreate
                        data={entity}
                        variant='copy'
                        ok={(data: IExportToolsDTO) => {
                            exportProvider.create(data, (id: string) => {
                                tabsContext.closeCurrent()
                                props.createdCallback?.()
                                setId(id)
                                setViewState("create")
                            })
                        }}
                        save={(data: IExportToolsDTO) => {
                            exportProvider.create(data, (id: string) => {
                                props.createdCallback?.()
                                setId(id);
                                setViewState('edit');
                            })
                        }}
                        cancel={() => tabsContext.closeCurrent()}
                    />
                )
            })
        }
    }

    function renderForm(): void {
        switch (viewState) {
            case "create": {
                renderCreator()
                break
            }
            case "edit": {
                renderEditor()
                break
            }
            case "copy": {
                renderCopy()
                break
            }
            default: {
                setForm(<></>)
            }
        }
    }

    return (
        <>
            {form}
        </>
    );
}